export const AUTH_TIMEOUT_MS = 5000;
